import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';
import {Routes} from '../Routes';
import Copyright from '../components/Copyright';




export default function ChangePassword() {
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log({
      email: data.get('email'),
      password: data.get('password'),
    });
  };

  return (
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {intl.get('resetpassword').d('Reset password')}
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          
			<Typography component="p" variant="caption">
				 {intl.get('entertheemailaddressyouregisteredwith').d('Enter the email address you registered with.')}             
            </Typography>
                
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label={intl.get('emailaddress').d('Email address')}
              name="email"
              autoComplete="email"
              autoFocus
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
               {intl.get('signin').d('Sign In')}
            </Button>
            <Grid container>
              <Grid item>
                <Link to={Routes.createAccount} variant="body2">
                  {intl.get('donthaveanaccountsignup').d('Don\'t have an account? Sign Up')}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
  );
}